import { colors, SearchIcon } from '@chegg-ui/theme';
import styled from 'styled-components';
import { IconButton } from '@chegg-ui/button';
export var LoadingWrapper = styled.div.withConfig({
  componentId: "wvecdm-0"
})(["display:flex;justify-content:center;margin-bottom:-5px;"]);
export var SchoolsDropdownWrapper = styled.div.withConfig({
  componentId: "wvecdm-1"
})(["", " width:", ";li:hover strong{color:inherit;}"], function (_ref) {
  var isLoading = _ref.isLoading;
  return isLoading ? "\n    li {\n      pointer-events: none;\n      background-color: ".concat(colors.white, ";\n    }\n  ") : '';
}, function (_ref2) {
  var width = _ref2.width;
  return width;
});
export var SchoolDescription = styled.div.withConfig({
  componentId: "wvecdm-2"
})(["white-space:initial;margin-top:4px;"]);
export var IconButtonWrapper = styled(IconButton).withConfig({
  componentId: "wvecdm-3"
})(["margin-right:-8px;"]);
export var SearchIconWrapper = styled(SearchIcon).withConfig({
  componentId: "wvecdm-4"
})(["padding:0.8125rem;margin-right:-8px;"]);
export var NotListedListboxOptionWrapper = styled.strong.withConfig({
  componentId: "wvecdm-5"
})(["color:", ";white-space:break-spaces;line-height:24px;", ""], colors.violet700, function (_ref3) {
  var isSelected = _ref3.isSelected;
  return isSelected && "\n      color: ".concat(colors.dark, "\n    ");
});